var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login__footer"},[_c('div',{staticClass:"container d-flex align-center"},[_c('div',{staticClass:"flex-grow-1"}),_c('img',{staticClass:"logo__mocero",attrs:{"src":require("@/assets/logo.png"),"alt":""}})])])
}]

export { render, staticRenderFns }